import type { FieldValues } from 'react-hook-form';
import { FormField, type FormFieldBaseProps } from './FormField';

export interface CheckboxFieldProps<T extends FieldValues>
  extends Omit<FormFieldBaseProps<T>, 'label'> {
  label: string;
  disabled?: boolean;
}

export function CheckboxField<T extends FieldValues>(
  props: CheckboxFieldProps<T>,
): JSX.Element {
  const { label, disabled, ...rest } = props;
  return (
    <FormField {...rest}>
      {({ value, onChange, onBlur, id }) => (
        <label htmlFor={id} className="flex items-center gap-2 cursor-pointer">
          <input
            id={id}
            type="checkbox"
            checked={!!value}
            onChange={(e) => onChange(e.target.checked)}
            onBlur={onBlur}
            disabled={disabled}
            className="h-4 w-4 rounded border-input text-primary focus:ring-ring"
          />
          <span className="text-sm">{label}</span>
        </label>
      )}
    </FormField>
  );
}
